import React, { Component } from 'react';
import { connect } from 'react-redux';
import './EntryBullet.css';
import {
  setSceneVideo,
  setHiliteId,
} from '../../../../../../../../redux/actions';
import { ASSETS_FOLDER } from '../../../../../../../../constants';
import * as Features from '../../../../../../../../utils/Features';

class EntryBullet extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleOver = this.handleOver.bind(this);
    this.handleOut = this.handleOut.bind(this);
  }

  handleClick() {
    const { data, position } = this.props;
    this.props.setSceneVideo(data.video, position);
  }

  handleOver() {
    this.props.setHiliteId(this.props.data.hilite);
  }

  handleOut() {
    this.props.setHiliteId('');
  }

  render() {
    const { completeVideos, data } = this.props;
    const { ico, video } = data;
    const isDone = completeVideos.indexOf(video) !== -1;

    return (
      <button
        className={`entry-bullet ${isDone ? 'done' : ''} ${
          Features.features.mobile ? 'mobile' : 'desktop'
        }`}
        onClick={this.handleClick}
        onMouseEnter={this.handleOver}
        onMouseLeave={this.handleOut}
      >
        <img
          className="ico-base"
          src={`${ASSETS_FOLDER}img/ico/bullet-line-${ico}.png`}
          alt=""
        />
        <img
          className="ico-hover"
          src={`${ASSETS_FOLDER}img/ico/bullet-line-play.png`}
          alt=""
        />
      </button>
    );
  }
}

const mapStateToProps = state => ({
  completeVideos: state.app.completeVideos,
});

const mapDispatchToProps = dispatch => ({
  setSceneVideo: (videoId, position) =>
    dispatch(setSceneVideo(videoId, position)),
  setHiliteId: hiliteId => dispatch(setHiliteId(hiliteId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryBullet);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/Timeline/TimeEntry/EntryGroup/EntryBullet/EntryBullet.js